var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle, _path36, _rect, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawRainingRe4B55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 807.6424,
    height: 701.91162,
    viewBox: "0 0 807.6424 701.91162",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M676.798,799.95708H662.03821a7.00787,7.00787,0,0,1-7-7V669.94292a7.00787,7.00787,0,0,1,7-7H676.798a7.00787,7.00787,0,0,1,7,7V792.95708A7.00787,7.00787,0,0,1,676.798,799.95708Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#645caa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M645.6056,799.95708H630.84607a7.00787,7.00787,0,0,1-7-7V669.94292a7.00787,7.00787,0,0,1,7-7H645.6056a7.00787,7.00787,0,0,1,7,7V792.95708A7.00787,7.00787,0,0,1,645.6056,799.95708Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#645caa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.88143,401.887c-2.988,12.51212-6.76245,15.49024-10.33734,14.63651s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S259.86941,389.37485,256.88143,401.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88143,619.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S251.86941,607.37485,248.88143,619.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M686.70567,230.26653s6.84838-14.48907-4.21835-18.25619-10.2707,11.40779-10.2707,11.40779l13.462,7.98918",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M454.16915,272.8972l-22.93674,18.59365s344.09481,115.64129,383.34,138.58172l-3.87352-32.40414-32.51049-39.59734-62.97416-40.17324L613.55975,286.27492,502.779,246.43546Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#645caa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M629.41332,319.13755,551.5648,513.43023s-12.44227,32.173,15.0539,38.33914c16.53169,3.70728,25.27069-6.32115,29.61152-14.90857,4.63649-9.17235-7.94938-17.23805-14.2396-9.11016q-.15319.19785-.307.40342c-.15376.20552-16.64748,13.00388-16.63786-4.51185a30.67974,30.67974,0,0,1,2.46411-11.74264l76.50617-183.74574Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M537.45738,285.91905",
    transform: "translate(-196.1788 -99.04419)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.22112,357.83627",
    transform: "translate(-196.1788 -99.04419)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M678.80412,222.02016s-21.906-3.19862-34.22716-10.1607c0,0-135.19936-28.77646-213.26059,78.57455,0,0,367.49,85.06751,383.34,138.58169,0,0,23.06518-99.03176-99.116-190.44493C715.54029,238.57072,685.64882,228.18258,678.80412,222.02016Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.96081,530.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S263.78405,523.12644,261.96081,530.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.9608,567.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S206.78405,560.12644,204.9608,567.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M623.88143,206.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S626.86941,194.37485,623.88143,206.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M636.96081,117.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S638.78405,110.12644,636.96081,117.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M579.9608,154.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S581.78405,147.12644,579.9608,154.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M465.88143,598.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S468.86941,586.37485,465.88143,598.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M478.96081,509.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S480.78405,502.12644,478.96081,509.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M421.9608,546.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S423.78405,539.12644,421.9608,546.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M406.88143,225.887c-2.988,12.51212-6.76245,15.49024-10.33734,14.63651s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S409.86941,213.37485,406.88143,225.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M398.88143,443.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S401.86941,431.37485,398.88143,443.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.96081,354.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S413.78405,347.12644,411.96081,354.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M354.9608,391.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S356.78405,384.12644,354.9608,391.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M559.88143,234.887c-2.988,12.51212-6.76245,15.49024-10.33734,14.63651s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S562.86941,222.37485,559.88143,234.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M551.88143,452.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S554.86941,440.37485,551.88143,452.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M564.96081,363.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S566.78405,356.12644,564.96081,363.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M701.88143,276.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S704.86941,264.37485,701.88143,276.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M657.9608,224.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S659.78405,217.12644,657.9608,224.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M772.88143,217.887c-2.988,12.51212-6.76245,15.49024-10.33734,14.63651s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S775.86941,205.37485,772.88143,217.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M764.88143,435.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S767.86941,423.37485,764.88143,435.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M777.96081,346.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S779.78405,339.12644,777.96081,346.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M914.88143,259.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S917.86941,247.37485,914.88143,259.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M870.9608,207.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S872.78405,200.12644,870.9608,207.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M855.88143,360.887c-2.988,12.51212-6.76245,15.49024-10.33734,14.63651s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S858.86941,348.37485,855.88143,360.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M847.88143,578.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S850.86941,566.37485,847.88143,578.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M860.96081,489.7612c-1.82325,7.63483-4.12641,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19421-16.83054,8.19421-16.83054S862.78405,482.12644,860.96081,489.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M997.88143,402.887c-2.988,12.51215-6.76245,15.49024-10.33734,14.63654s-5.59647-5.21594-2.60849-17.728,13.42889-27.58233,13.42889-27.58233S1000.86941,390.37485,997.88143,402.887Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M953.9608,350.7612c-1.82324,7.63483-4.1264,9.452-6.30777,8.93109s-3.41492-3.18274-1.59169-10.81756,8.19422-16.83057,8.19422-16.83057S955.78405,343.12644,953.9608,350.7612Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 467.90102,
    cy: 378.15166,
    r: 51,
    fill: "#645caa"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M623.04187,498.605c-3.30639-.09228-7.42138-.208-10.5896-2.52246a8.13346,8.13346,0,0,1-3.20019-6.07324,5.47053,5.47053,0,0,1,1.8606-4.49219c1.65527-1.39941,4.073-1.72754,6.678-.96143l-2.699-19.72607,1.98144-.27148,3.1731,23.19043-1.65454-.75928c-1.91821-.8794-4.551-1.32715-6.188.05517a3.51383,3.51383,0,0,0-1.15283,2.89453,6.14689,6.14689,0,0,0,2.3811,4.52833c2.46558,1.80175,5.74561,2.03417,9.46607,2.13867Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432.34208,
    y: 367.48662,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M667.64793,426.045a42.16089,42.16089,0,0,1,16.48679-30.88561,41.06466,41.06466,0,0,1,35.01478-6.678A40.44121,40.44121,0,0,1,746.032,411.41995a42.10754,42.10754,0,0,1,3.61014,17.69246,47.83336,47.83336,0,0,1-4.83069,19.06711c-3.00716,6.55216-6.8,12.69925-10.094,19.10425a152.46028,152.46028,0,0,0-8.37723,19.557,154.17895,154.17895,0,0,0-8.32173,42.37385c-1.22412,22.77069.95445,56.01429,26.66,64.753,6.53681,2.22223,13.58849,2.636,20.442,2.61783a83.952,83.952,0,0,0,21.42038-2.509c12.13545-3.24045,23.65553-10.84962,28.82639-22.67174a31.55294,31.55294,0,0,0,2.373-8.56911c.10763-.80991-.7666-1.49235-1.5-1.5a1.53686,1.53686,0,0,0-1.5,1.5c-1.67411,12.59789-12.17164,22.25885-23.56928,26.60212a67.697,67.697,0,0,1-20.73581,4.01122c-7.04626.356-14.36228.30089-21.26181-1.32054a30.7922,30.7922,0,0,1-16.01386-9.1029,41.40161,41.40161,0,0,1-8.35941-15.12233c-4.05744-12.38511-4.48264-26.00217-3.76968-38.91066a151.26213,151.26213,0,0,1,8.49775-42.19341,147.93246,147.93246,0,0,1,8.80388-19.95791c3.34244-6.28625,7.05366-12.39482,9.86985-18.94722a49.44352,49.44352,0,0,0,4.44457-19.15341,45.24383,45.24383,0,0,0-3.5757-17.79309,43.37046,43.37046,0,0,0-25.81022-24.36088,44.64077,44.64077,0,0,0-36.0158,2.95013,45.38508,45.38508,0,0,0-21.25517,27.7329,43.42418,43.42418,0,0,0-1.3417,8.77531c-.09889,1.92955,2.90139,1.92422,3,0Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#2f2e41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M677.62119,427.09819a23.48752,23.48752,0,0,1,7.85694-14.33284,23.16913,23.16913,0,0,1,16.195-5.37552c1.92969.09652,1.92457-2.90373,0-3a26.1035,26.1035,0,0,0-26.94473,21.91084c-.28827,1.88869,2.602,2.70292,2.89283.79752Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#2f2e41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M664.07981,418.19585h15a5,5,0,0,1,5,5v0a5,5,0,0,1-5,5h-15a5,5,0,0,1-5-5v0a5,5,0,0,1,5-5Z",
    transform: "translate(980.4327 936.57078) rotate(-161.72778)",
    fill: "#2f2e41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M700.21985,714.38823H606.4303a6.50736,6.50736,0,0,1-6.5-6.5V693.129a6.50736,6.50736,0,0,1,6.5-6.5h93.78955a6.50736,6.50736,0,0,1,6.5,6.5v14.75927A6.50736,6.50736,0,0,1,700.21985,714.38823Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#ccc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M720.20057,692.04888c-.04688,0-.09351-.00049-.14038-.00147l-131.15186-2.76123a6.5,6.5,0,0,1-6.19995-7.9458l31.93237-139.80029a6.46719,6.46719,0,0,1,6.33667-5.05274h21.376A65.89238,65.89238,0,0,1,706.57532,588.667l19.98413,95.55078a6.50038,6.50038,0,0,1-6.35888,7.83106Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M635.94056,612.95708a6.47993,6.47993,0,0,1-4.5669-1.87158L543.84778,524.646a6.49984,6.49984,0,0,1-.05737-9.19239l10.37109-10.502a6.50041,6.50041,0,0,1,9.19214-.05713l87.52588,86.439a6.50815,6.50815,0,0,1,.05737,9.19287L640.5658,611.02788A6.48152,6.48152,0,0,1,635.94056,612.95708Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#645caa"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M631.89384,615.5754l-38.48668-37.55346a6.52535,6.52535,0,0,1-.324-9.001L609.28257,550.762a6.52535,6.52535,0,0,1,10.07623.382l41.18057,41.96982a6.53721,6.53721,0,0,1-.48446,9.21389l-18.93735,13.73618A6.537,6.537,0,0,1,631.89384,615.5754Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#2f2e41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.63051,800.95581H264.3365a1.19069,1.19069,0,1,1,0-2.38137h738.294a1.19069,1.19069,0,1,1,0,2.38137Z",
    transform: "translate(-196.1788 -99.04419)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawRainingRe4B55);
export default __webpack_public_path__ + "static/media/undraw_raining_re_4b55.03d5aa567782c7e2525a891663a42b32.svg";
export { ForwardRef as ReactComponent };